import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDatePicker from "../../../components/CommonDatePicker";
import SelectBox from "../../../components/SelectBox";
import {
  allocatedAlerts,
  companyDetails,
  recentAlerts,
  siteDetails,
} from "../../redux/api/dummyJson";
import { Table } from "../../../components/Table/Table";
import { search_icon, view_icon } from "../../../assets/imgs";
import { URL } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import moment from "moment/moment";

const Recent = ({
  site,
  siteList,
  sites,
  setSites,
  companies,
  setCompanies,
}) => {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [list, setList] = useState([]);

  const [typeDrop, setTypeDrop] = useState(null);
  const [cam, setCam] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [classified, setClassified] = useState(null);
  const [camera, setCamera] = useState([]);
  const [type, setType] = useState([]);

  const givenuser = JSON.parse(localStorage.getItem("user_details"));

  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Date and Time",
        accessor: "captured_at",
        Cell: ({ value, row }) => {
          return (
            <p> {value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"}</p>
          );
        },
      },
      {
        Header: "Camera Number",
        accessor: "camera_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Camera Name",
        accessor: "camera_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Classified",
        accessor: "classified",
        Cell: ({ value, row }) => {
          return (
            <p>
              {value == 1
                ? "New"
                : value == 2
                ? "Invalid"
                : value == 3
                ? "Compliant"
                : value == 4
                ? "Non - Compliant"
                : ""}
            </p>
          );
        },
      },
      //     ...(site
      // ? [
      //     {
      //       Header: "Site Name",
      //       accessor: "siteName",
      //       Cell: ({ value, row }) => {
      //         return <p>{value}</p>;
      //       },
      //     },
      //   ]
      // : []),
      {
        Header: "Alert Type",
        accessor: "alert_type",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Severity",
        accessor: "severity",
        Cell: ({ value, row }) => {
          return <p className="d-flex ac-jc">{value}</p>;
        },
      },
      //   {
      //     Header: "Description",
      //     accessor: "description",
      //     Cell: ({ value, row }) => {
      //       return <p>{value}</p>;
      //     },
      //   },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                {row.original.role != "Super Admin" && (
                  <button
                    onClick={() => {
                      navigate("/view-notification-com-details", {
                        state: {
                          data: row?.original,
                          type: "new",
                        },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [site, page]
  );

  //   console.log("location", location?.state);

  const getCameraList = () => {
    let formdata = new FormData();
    formdata.append("site_id", location?.state?.data?.id);
    // formdata.append("site_id", 2);
    post(URL.CAMERA_LISTS, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          setCamera(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAlertTypes = () => {
    get(URL.GROUP_USERS + location?.state?.data?.id)
      .then((res) => {
        console.log("res", res);

        if (res?.data?.alert_types?.length > 0) {
          let temp = [];
          res?.data?.alert_types?.map((item, ind) => {
            let obi = {
              ...item,
            };
            obi.id = item?.alert_type_id;
            obi.name = item?.alert_name;
            temp.push(obi);
          });
          console.log("temp", temp);

          setType(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getNotification = (
    from_date,
    to_date,
    search_value,
    type_value,
    camera_id,
    severity_type,
    page_no
  ) => {
    let formdata = new FormData();
    formdata.append("page", page_no);
    formdata.append("type", 1);
    formdata.append("site_id", sites?.value);

    if (camera_id?.value) {
      formdata.append("camera_id", camera_id?.value);
    }
    if (from_date) {
      formdata.append("from_date", moment(from_date).format("DD-MM-YYYY"));
    }
    if (to_date) {
      formdata.append("to_date", moment(to_date).format("DD-MM-YYYY"));
    }
    if (type_value?.value) {
      formdata.append("alert_id", type_value?.value);
    }

    if (search_value) {
      formdata.append("search", search_value);
    }

    setSearchText(search_value);
    setFromDate(from_date);
    setToDate(to_date);
    setCam(camera_id);
    setTypeDrop(type_value);
    post(URL.USER_NOTIFICATION, formdata)
      .then((res) => {
        if (res?.status == "success") {
          setList(res?.lists);
          setPagination(res?.pagination_meta);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  //   useEffect(() => {
  //     getCameraList();
  //     getAlertTypes();
  //   }, []);

  useEffect(() => {
    if (sites?.value) {
      getNotification(fromDate, toDate, searchText, typeDrop, cam, 1, page);
    } else {
      setList([]);
      setPagination({});
    }
  }, [page, sites]);

  const getFromDate = (date) => {
    getNotification(date, toDate, searchText, typeDrop, cam, 1, page);
  };

  const getToDate = (date) => {
    getNotification(fromDate, date, searchText, typeDrop, cam, 1, page);
  };

  return (
    <div className="">
      <h2 className="f3 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-3">
        Total: {pagination?.total ?? 0}
      </h2>
      {site != "site" ? (
        <div className="col-md-2 ">
          <label className="form-label">Select Site</label>
          <SelectBox
            arrayData={siteList}
            data={data}
            setData={setData}
            selectedOption={sites}
            setSelectedOption={setSites}
            style={true}
          />
        </div>
      ) : (
        <div className="col-md-2"></div>
      )}
      <div className="d-flex ac-js gap-5 m-2">
        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        {site == "admin" && (
          <div className="col-md-2 ">
            <label className="form-label">Select Company</label>
            <SelectBox
              arrayData={companyDetails}
              data={companyData}
              setData={setCompanyData}
              selectedOption={companies}
              setSelectedOption={setCompanies}
              style={true}
            />
          </div>
        )}

        <div className="search-input" style={{ marginTop: "32px" }}>
          <input
            onChange={(e) => {
              setSearchText(e.target.value);
              // getNotification(
              //   fromDate,
              //   toDate,
              //   e.target.value,
              //   typeDrop,
              //   cam,
              //   sites,
              //   page
              // );
            }}
            value={searchText}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
          />
          <img src={search_icon} className="search" />
        </div>

        <div className="d-flex flex-row justify-content-end col-md-3 gap-2">
          <button
            className="submit-btn mt-4"
            style={{ width: "100px" }}
            onClick={() =>
              getNotification(
                fromDate,
                toDate,
                searchText,
                typeDrop,
                cam,
                1,
                page
              )
            }
            // onClick={() => getNotification("", "", "", "", "", "", 1)}
          >
            Filter
          </button>
          <button
            className="submit-btn mt-4"
            style={{ width: "100px" }}
            onClick={() => getNotification("", "", "", "", "", "", 1)}
          >
            Refresh
          </button>
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default Recent;
